import { render } from "./AddEditProductGroup.vue?vue&type=template&id=583c84f8&scoped=true"
import script from "./AddEditProductGroup.vue?vue&type=script&lang=js"
export * from "./AddEditProductGroup.vue?vue&type=script&lang=js"

import "./AddEditProductGroup.vue?vue&type=style&index=0&id=583c84f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583c84f8"]])

export default __exports__